import { Signature, Section, BannerItem, Template, Logo } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';
import { ApiRequest, Reducer } from 'store/store';
import { initialApiRequest } from 'store/store-tools';

export const initialState: {
    body: ApiRequest<string>,
    info: ApiRequest<Signature>,
    sections: ApiRequest<Section[]>,
    logos: ApiRequest<Logo[]>,
    isSavingInfo: boolean,
    searchBanners: ApiRequest<BannerItem[]>,
    template: ApiRequest<Template>,
} = {
    body: initialApiRequest(),
    info: initialApiRequest(),
    sections: initialApiRequest(),
    logos: initialApiRequest(),
    isSavingInfo: false,
    searchBanners: initialApiRequest(),
    template: initialApiRequest(),
} as const;

export type SignatureState = typeof initialState;

const signature: Reducer<SignatureState> = (state = initialState, action) => {
    switch (action.type) {
        case '@SIGNATURE/FETCH_SIGNATURE_BODY':
            return {
                ...state,
                body: {
                    ...state.body,
                    state: 'isFetching',
                },
            };

        case '@SIGNATURE/FETCH_SIGNATURE_BODY_SUCCESS':
            return {
                ...state,
                body: {
                    ...state.body,
                    data: action.payload.signature || '',
                    state: 'valid',
                },
            };

        case '@SIGNATURE/FETCH_SIGNATURE_BODY_FAILURE':
            return {
                ...state,
                body: {
                    ...state.body,
                    state: 'error',
                },
            };

        case '@SIGNATURE/FETCH_SIGNATURE_INFO':
            return {
                ...state,
                info: {
                    ...state.info,
                    state: 'isFetching',
                },
            };

        case '@SIGNATURE/FETCH_SIGNATURE_INFO_SUCCESS':
            return {
                ...state,
                info: {
                    ...state.info,
                    data: action.payload.info || undefined,
                    state: 'valid',
                },
            };

        case '@SIGNATURE/FETCH_SIGNATURE_INFO_FAILURE':
            return {
                ...state,
                info: {
                    ...state.info,
                    state: 'error',
                },
            };

        case '@SIGNATURE/SAVE_SIGNATURE_INFO':
            return {
                ...state,
                isSavingInfo: true,
            };

        case '@SIGNATURE/SAVE_SIGNATURE_INFO_SUCCESS':
            return {
                ...state,
                isSavingInfo: false,
                info: {
                    ...state.info,
                    state: 'outdated',
                },
                body: {
                    ...state.body,
                    state: 'outdated',
                },
            };

        case '@SIGNATURE/SAVE_SIGNATURE_INFO_FAILURE':
            return {
                ...state,
                isSavingInfo: false,
            };

        case '@SIGNATURE/FETCH_ALL_SECTIONS':
            return {
                ...state,
                sections: {
                    ...state.sections,
                    state: 'isFetching',
                },
            };

        case '@SIGNATURE/FETCH_ALL_SECTIONS_SUCCESS':
            return {
                ...state,
                sections: {
                    ...state.sections,
                    data: action.payload.sections || undefined,
                    state: 'valid',
                },
            };

        case '@SIGNATURE/FETCH_ALL_SECTIONS_FAILURE':
            return {
                ...state,
                sections: {
                    ...state.sections,
                    state: 'error',
                },
            };

        case '@SIGNATURE/SEARCH_BANNERS':
            return {
                ...state,
                searchBanners: {
                    ...state.searchBanners,
                    state: 'isFetching',
                },
            };

        case '@SIGNATURE/SEARCH_BANNERS_SUCCESS':
            return {
                ...state,
                searchBanners: {
                    ...state.searchBanners,
                    data: action.payload.searchBanners,
                    state: 'valid',
                },
            };

        case '@SIGNATURE/SEARCH_BANNERS_FAILURE':
            return {
                ...state,
                searchBanners: {
                    ...state.searchBanners,
                    state: 'error',
                },
            };

        case '@SIGNATURE/GET_TEMPLATE_BY_ID':
            return {
                ...state,
                template: {
                    ...state.template,
                    state: 'isFetching',
                },
            };

        case '@SIGNATURE/GET_TEMPLATE_BY_ID_SUCCESS':
            return {
                ...state,
                template: {
                    ...state.template,
                    data: action.payload.template,
                    state: 'valid',
                },
            };

        case '@SIGNATURE/GET_TEMPLATE_BY_ID_FAILURE':
            return {
                ...state,
                template: {
                    ...state.template,
                    state: 'error',
                },
            };

        case '@SIGNATURE/FETCH_ALL_LOGOS':
            return {
                ...state,
                logos: {
                    ...state.logos,
                    state: 'isFetching',
                },
            };

        case '@SIGNATURE/FETCH_ALL_LOGOS_SUCCESS':
            return {
                ...state,
                logos: {
                    ...state.logos,
                    data: action.payload.logos || undefined,
                    state: 'valid',
                },
            };

        case '@SIGNATURE/FETCH_ALL_LOGOS_FAILURE':
            return {
                ...state,
                logos: {
                    ...state.logos,
                    state: 'error',
                },
            };

        default:
            return state;
    }
};

export default signature;
